/**
 * WebComponents Initializer
 * Handles initialization logic when designsystem-webcomponents.js loads
 */

// Initialize when document is loaded
function initializeWebComponents() {
  try {
    const managers = document.getElementsByTagName('ts-settings-manager')
    if (managers.length === 0) {
      document.body.insertAdjacentHTML('afterbegin', '<ts-settings-manager></ts-settings-manager>')
      console.log('<ts-settings-manager> added')
    }
    console.log('WebComponents initialized')
  } catch (e) {
    console.error('Error initializeWebComponents', e)
  }
}

// Run when document is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWebComponents)
} else {
  // DOM is already loaded, run immediately
  initializeWebComponents()
}
